import Vue from 'vue';
import Constants from '../helpers/Constants';

export default {
  namespaced: true,

  state: {
  },

  getters: {
    menuItems: (state, getters) => [
      {
        text: 'User Analytics',
        icon: 'mdi-google-analytics',
        link: 'analytics',
        access_rule: getters.pages.analytics,
      },
      {
        text: 'Content Statistics',
        icon: 'mdi-map-search',
        link: 'destination_analytics',
        access_rule: getters.pages.statistics,
      },
      {
        text: 'Video Assets Library',
        icon: 'mdi-file-video',
        link: 'tripbits_videos',
        access_rule: Vue.prototype.hasAllAbilities(Constants.ABILITY.VIDEO_ASSETS),
      },
      {
        text: 'Customer Management',
        icon: 'mdi-book-cog',
        link: 'customerManagement',
        access_rule: Vue.prototype.hasAllAbilities(Constants.ABILITY.CUSTOMER_MANAGEMENT),
      },
      {
        text: 'User Management',
        icon: 'mdi-account-details',
        link: 'userManagement',
        access_rule: Vue.prototype.hasAllAbilities(Constants.ABILITY.USER_MANAGEMENT),
      },
      {
        text: 'Dashboard Management',
        icon: 'mdi-view-dashboard',
        link: 'dashboardManagement',
        access_rule: Vue.prototype.hasAllAbilities(Constants.ABILITY.DASHBOARD_MANAGEMENT),
      },
      {
        text: 'Exports',
        icon: 'mdi-export',
        link: 'exports',
        access_rule: Vue.prototype.hasAllAbilities(Constants.ABILITY.EXPORT),
      },
      {
        text: 'History',
        icon: 'mdi-history',
        link: 'history',
        target: '_blank',
        access_rule: !Vue.prototype.hasAnyAbility(Constants.ABILITY.CUSTOMER),
      },
    ],

    // eslint-disable-next-line max-len
    filteredMenuItems: (state, getters) => getters.menuItems.filter((el) => el.access_rule === true),

    menuServices: () => [
      // {
      //   text: 'Tail Numbers Report',
      //   icon: 'mdi-file-chart',
      //   link: 'tailNumbersReport',
      //   access_rule: Vue.prototype.hasAllAbilities(
      //   Constants.ABILITY.SERVICE_TAIL_NUMBERS_REPORT
      //   ),
      // },
      {
        text: 'Customer Logs Tracking',
        icon: 'mdi-cctv',
        link: 'logsTracking',
        access_rule: Vue.prototype.hasAnyAbility(
          Constants.ABILITY.SERVICE_LOGS_TRACKING_30_M,
          Constants.ABILITY.SERVICE_LOGS_TRACKING_1_H,
          Constants.ABILITY.SERVICE_LOGS_TRACKING_1_D,
        ),
      },
    ],

    // eslint-disable-next-line max-len
    filteredMenuServices: (state, getters) => getters.menuServices.filter((el) => el.access_rule === true),

    pages: (state, getters, rootState, rootGetters) => rootGetters['auth/pages'],
  },

  mutations: {
  },

  actions: {
  },
};
